import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthApiService } from '../services/auth/auth-api.service';
import { ToastrService } from 'ngx-toastr';

export const isLoggedInGuard: CanActivateFn = () => {
  const authService = inject(AuthApiService);
  const router = inject(Router);
  const toastr = inject(ToastrService);

  if (authService.isLoggedIn()) {
    return true;
  }
  toastr.warning('Vous devez être connecté pour accéder à cette page', 'Accès refusé');
  return router.createUrlTree(['/']);
};
